import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import styles from './app.module.css';
import { LicenseInfo } from '@mui/x-license';

import { routes } from './routes';
const MUI_KEY = process.env.NX_PUBLIC_MUI_LICENSE_KEY;

LicenseInfo.setLicenseKey(MUI_KEY);
const router = createBrowserRouter(routes, { basename: '/integrations' });

export function App() {
  return <RouterProvider router={router} />;
}

export default App;
